export const attributePrefix = 'data-metrics';

export default {
  attributePrefix,
  useTrackBinding: false,
};
